import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { AppService } from 'src/app/_services/app.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  userInfo: any;
  constructor(
    private appService: AppService
    ) { }

  ngOnInit(): void {
    $('.droptitle').click(function () {
      $(this).toggleClass('active');
      $(this).next('ul').slideToggle();
      $('.droptitle').not(this).next('ul').slideUp();
      $('.droptitle').not(this).removeClass('active');
    });

    
    this.appService.postService({}, 'login/GetUserInfo').subscribe(response => {
      this.userInfo = response.body.result
      console.log(this.userInfo);
      this.appService.userInfo.next(this.userInfo)
    })
  }

}
